/**
 * Issue Activities API Service
 *
 * Service functions for interacting with the issue activities API endpoints.
 */

import { apiClient } from "./api";
import type { IssueActivity } from "@/types/issueActivity";

const API_PREFIX = "/api/v1/security-issues";

/**
 * Paginated response from backend
 */
export interface PaginatedActivitiesResponse {
  data: IssueActivity[];
  total_count: number;
  has_more: boolean;
  page: number;
  items_per_page: number;
}

/**
 * List activities for a security issue.
 * @param issueId - The numeric ID of the issue
 * @param page - The page number (default: 1)
 * @param itemsPerPage - The number of items per page (optional)
 */
export async function listIssueActivities(
  issueId: number,
  page: number = 1,
  itemsPerPage?: number
): Promise<PaginatedActivitiesResponse> {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  if (itemsPerPage !== undefined) {
    params.append("items_per_page", itemsPerPage.toString());
  }
  return apiClient.get<PaginatedActivitiesResponse>(
    `${API_PREFIX}/${issueId}/activities?${params.toString()}`
  );
}
